import { ChronoCodeLevelVO } from '../../core/chronocodelevel.vo';
import { FreeDataVO } from '../../core/freedata.vo';

/** encapsulation d'un ChronocodeVO ou d'un freedataVO pour constituer une clé / un filtre / un potentiel */
export class VisionKeyObj {
  public static SEPARATOR: string = '#';
  public static CHRONO: string = 'CRO';
  public static FREEDATA: string = 'FDV';

  public baseCode: string; // la clé CODE uniquement. Pour comparer les hiérarchies
  public code: string; // la clé CODE#level (si level)
  public source: ChronoCodeLevelVO | FreeDataVO; // le VO source, soit un chronocodeVO, soit une freedataVO

  public state: 'free' | 'key' | 'filterkey'; // la zone de ventilation

  public kind: 'CRO' | 'FDV'; // selon le type
  public isFreedata: boolean = false;
  public isChronocode: boolean = false;

  public isWild: boolean = false; // c'est un FD "Free", avec ajout possible de valeurs à la volée

  public level: number = 0; // niveau pour les axes gigognes et les chronocodes
  public order: number = 0; // ordre dans la composition de la clé

  public stepLevel: number = 0; // step d'affectation

  /** accesseur sur le libellé traduit */
  public get label(): string {
    if (this.isChronocode) {
      return this.source.trsLabel;
      // return '(CRON) ' +  this.source.trsLabel;
    } else {
      // if (this.level > 0) { // freedata gigogne, collecte du libellé du niveau
      const lvlStr: string = (this.source as FreeDataVO).levelsVOMap.get(this.level).trsLabel;
      return this.source.trsLabel + ' - ' + lvlStr; // le libellé du FD et le libellé du niveau
      // } else {
      //   return this.source.trsLabel;
      // }
    }
  }

  /** libellé ordre + label */
  public get orderAndlabel(): string {
    return this.order + ' - ' + this.label;
  }

  public constructor(
    source: ChronoCodeLevelVO | FreeDataVO,
    state: 'free' | 'key' | 'filterkey',
    order: number = 0,
    level: number = 0
  ) {
    this.source = source;
    if (this.source instanceof ChronoCodeLevelVO) {
      this.isChronocode = true;
      this.kind = 'CRO';
    } else if (this.source instanceof FreeDataVO) {
      this.isFreedata = true;
      this.isWild = (this.source as FreeDataVO).kindWild;
      this.kind = 'FDV';
    }
    this.baseCode = source.code;
    this.code = source.code + VisionKeyObj.SEPARATOR + level;
    // if (level > 0) {
    //   this.code += VisionKeyObj.SEPARATOR + level;
    // }
    this.state = state;
    this.order = order;
    this.level = level;
  }
}
